module.exports = __webpack_public_path__ + "static/media/globe-americas.366aaf85.svg";